module.exports = __webpack_public_path__ + "static/img/RAPS600_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS600_1.png
// module id = U9oy
// module chunks = 0